import { render, staticRenderFns } from "./loyalty-multiple-offers.vue?vue&type=template&id=20115cd5&scoped=true"
import script from "./loyalty-multiple-offers.ts?vue&type=script&lang=ts&external"
export * from "./loyalty-multiple-offers.ts?vue&type=script&lang=ts&external"
import style0 from "./loyalty-multiple-offers.scss?vue&type=style&index=0&id=20115cd5&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20115cd5",
  null
  
)

export default component.exports